"use client";

import React, { useState, useRef } from "react";
import Sorabh from "../../public/neet-pg/sourabh_mehta.webp";
import Sneha from "../../public/neet-pg/sneha_rana.webp";
import Faiz from "../../public/neet-pg/md faiz khan (pg).webp";
import Swapnil from "../../public/neet-pg/Dr Swapnil.webp";
import Deepshikha from "../../public/neet-pg/dr.deepshika jain.webp";
import Imran from "../../public/neet-pg/dr. Imran ahemad.webp";
import Shruti from "../../public/neet-pg/dr. shruti shakya.webp";
import Subham from "../../public/neet-pg/dr. shubham sharma.webp";
import Shivani from "../../public/neet-pg/dr.shivani sonam.webp";
import Shreya from "../../public/neet-pg/dr. shreya jaiswal.webp";
import Vivekanand from "../../public/neet-pg/dr. vivekanand gupta.webp";
import { RiDoubleQuotesL, RiDoubleQuotesR } from "react-icons/ri";

const testimonials = [
  {
    name: "Dr. Md. Faiz Khan",
    title: "Secured General Medicine after 3 Rounds",
    subtitle: "AIR 12,530",
    text: "Dr. Md. Faiz Khan faced a lot of anxiety and fear about securing a seat in General Medicine despite having an All India Rank of 12,530. The uncertainty of the counselling process weighed heavily on him, and he often felt overwhelmed and unsure about his future.\n\nHe joined NEET Support hoping for guidance, but the journey was far from easy. He had to wait through three long rounds of counselling, each filled with tension and disappointment, holding on to the slim hope of getting his dream branch. There were moments when it seemed he might have to give up and settle for another specialty, and the thought was truly disheartening for him.\n\nYet, through all the worry, patience, and determination, he finally achieved what he had been longing for admission in Bankura Sammilani Medical College, West Bengal, in General Medicine.\n\nHis journey reminds us that even in moments of despair and uncertainty, perseverance and trust in the process can eventually lead to the dreams we almost lost hope of achieving.",
    image: Faiz,
  },

  {
    name: "Dr. Sneha Rana",
    title: "Secured OBG in Her Dream College",
    subtitle: "AIR 13,949",
    text: "Dr. Sneha Rana with an All India Rank of 13,949 had a brilliant rank and a clear dream — to study OBG in a government medical college. With the expert guidance of NEET Support, she confidently navigated the counselling rounds.\n\nIn Round 1-she secured Doon Medical College, Uttarakhand, in Round 2- she got Jawaharlal Medical College, Jabalpur. But her perseverance and clarity of purpose finally led her to her dream college — GMERS Porbandar!\n\nAs a young woman determined to specialize in OBG, this journey was both challenging and exciting. Her story shows that with guidance, determination, and focus, even the toughest paths can lead to a dream destination.",
    image: Sneha,
  },

  {
    name: "Dr. Shruti Shakya",
    title: "Secured General Surgery in GMC Shivpuri",
    subtitle: "AIR 15,746",
    text: "Dr. Shruti Shakya faced the intense competition of NEET with determination and energy! With an All India Rank of 15,746, she was determined to secure a government medical college and pursued her dream relentlessly.\n\nWith the expert guidance of NEET Support, who were always there to answer her questions and guide her through the counselling rounds, she tackled every challenge with focus and confidence. No query was too small, no hurdle too big — she remained committed to her goal.\n\nHer hard work and perseverance paid off spectacularly when she secured admission in Government Medical College, Shivpuri, in her dream branch of General Surgery. Dr. Shruti’s journey proves that with energy, focus, and guidance, even the toughest challenges can be turned into amazing achievements!",
    image: Shruti,
  },

  {
    name: "Dr. Shreya Jaiswal",
    title: "Secured Anaesthesia in Mumbai",
    subtitle: "AIR 41,906",
    text: "Dr. Shreya Jaiswal dreamed of pursuing Anaesthesia at one of the top medical colleges in Maharashtra. With an All India Rank of 41,906, the journey seemed challenging, but she refused to let the competition or uncertainty deter her.\n\nJoining NEET Support became the turning point in her journey. With expert guidance, personalized counselling, and unwavering encouragement from the team, Dr. Shreya navigated every step of the counselling process with confidence and clarity. She stayed focused, asked the right questions, and followed the strategy laid out by her counsellors, turning every obstacle into an opportunity.\n\nHer hard work and determination bore fruit when she earned a seat in KJ Somaiya Medical College, Mumbai, in Anaesthesia, turning her long-cherished dream into reality.\n\nDr. Shreya’s journey is a shining example of how determination, expert guidance, and a never-give-up attitude can turn ambitious dreams into reality, even in the toughest competitive environment.",
    image: Shreya,
  },

  {
    name: "Dr. Sourabh Mehta",
    title: "General Medicine Secured",
    subtitle: "AIR 46,253",
    text: "Dr. Sourabh Mehta (AIR 46,253) initially aimed to secure a government medical college. Although his rank was good, he could not get a government seat. However, he never lost hope because his ultimate goal was always clear — to pursue MD/MS, especially in General Medicine.\n\nStaying focused on his dream, he trusted the counselling process and secured admission to Varun Arjun Medical College, Shahjahanpur, in the branch he truly wanted — General Medicine. The best part for him is that the college is close to his hometown, making it even more convenient.\n\nHis journey shows that even if things don’t go exactly as planned, staying determined can still lead you to the right destination.",
    image: Sorabh,
  },

  {
    name: "Dr. Deepshikha Jain",
    title: "Secured Dermatology in Rajasthan",
    subtitle: "AIR 58,669",
    text: "Dr. Deepshikha Jain dreamed of specializing in Dermatology and was determined to achieve her goal. With the expert guidance of NEET Support throughout the Rajasthan counselling process, she approached every step with patience and confidence, navigating the competition with a clear focus on her dream branch.\n\nEven with an All India Rank of 58,669, she never lost hope. The NEET Support team assisted her with personalised strategies and constant encouragement, helping her stay motivated through the entire counselling journey. Her persistence and dedication paid off when she secured admission in MGM Medical College, Jaipur, in Dermatology, the branch she was truly passionate about.\n\nDr. Deepshikha’s journey is a testament to how guidance, focus, and perseverance can turn even challenging dreams into reality.",
    image: Deepshikha,
  },

  {
    name: "Dr. Imran Ahemad",
    title: "Secured Paediatrics in PGIMS Rohtak",
    subtitle: "AIR 61,375",
    text: "Dr. Imran Ahemad, despite a busy work schedule, secured one of the top government medical colleges in Haryana with his All India Rank of 61,375. As he could not give full attention to the counselling process, the NEET Support service team managed his entire counselling on his behalf, ensuring that every step was handled with care and precision.\n\nWith their guidance and support, Dr. Imran successfully secured admission in PGIMS Rohtak, Haryana, in Paediatrics, achieving his goal without compromise.\n\nHis journey demonstrates that even when personal circumstances limit direct involvement, the right guidance, support, and perseverance can help turn dreams into reality.",
    image: Imran,
  },

  {
    name: "Dr. Subham Sharma",
    title: "Secured Dream College in Mop-Up Round",
    subtitle: "AIR 63,383",
    text: "Dr. Subham Sharma, with an All India Rank of 63,383, faced stiff competition and did not have a top rank, but he never gave up. With focus, determination, and the guidance of NEET Support, he successfully secured Index Medical College, Indore in the first round. However, he remained determined to join Peoples Medical College, Bhopal, and with full dedication and support from NEET Support, he secured his preferred college in the mop-up round.\n\nDuring the process, an unexpected issue arose when an NRI student filed a case that caused tension for many candidates, including Dr. Subham. Despite completing the admission process, he felt anxious about the legal uncertainty. The NEET Support team provided reassurance and guidance, helping him trust the process and relax.\n\nIn the end, Dr. Subham secured his dream college, and his experience left him not only relieved but also deeply appreciative of the support and guidance of NEET Support.\n\nHis journey shows that with persistence, trust, and the right guidance, even challenges that seem overwhelming can be overcome.",
    image: Subham,
  },

  {
    name: "Dr. Shivani Soam",
    title: "Secured Anaesthesia with Friend",
    subtitle: "AIR 1,14,740",
    text: "Dr. Shivani Soam, with an All India Rank of 1,14,740, joined NEET Support during the final (3rd) round of counselling, hoping to secure a seat only in Anaesthesia, her preferred branch. She was also eager to be in the same college as her friend.\n\nWith the expert guidance of the NEET Support team, her wishes were fully supported. The team ensured that both friends could get seats together in the same college, without compromising on her preferred branch.\n\nIn the end, Dr. Shivani successfully secured admission in NIIMS, Noida, in Anaesthesia, achieving both her dream branch and the chance to study alongside her friend. Her journey highlights how focused guidance, determination, and teamwork can make even last-minute goals possible.",
    image: Shivani,
  },

  {
    name: "Dr. Vivekanand Gupta",
    title: "Secured Anaesthesia despite High Rank",
    subtitle: "AIR 1,88,885",
    text: "Dr. Vivekanand Gupta faced the challenge of securing a medical college with an All India Rank of 1,88,885, but he remained determined to pursue his dream of studying Anaesthesia. With dedication, focus, and the guidance of NEET Support, he navigated the competitive counselling process with confidence.\n\nDespite the odds, the expert counselling team helped him explore all possible options, providing timely advice and encouragement throughout the process. His perseverance and trust in the guidance he received paid off when he successfully secured admission in Madhubani Medical College, Bihar, in his preferred branch of Anaesthesia.\n\nDr. Vivekanand’s journey is a testament to how determination, expert guidance, and never giving up can turn even a challenging situation into a success story.",
    image: Vivekanand,
  },

  {
    name: "Dr. Swapnil Gupta",
    title: "Secured E.N.T despite High Rank",
    subtitle: "AIR 1,95,226",
    text: "Dr. Swapnil Gupta, with an All India Rank of 195,226, joined NEET Support with almost no hope of securing a medical college due to his high rank. Understanding his situation, a senior counsellor was assigned to provide full guidance, assisting him even during late-night sessions.\n\nAt the midpoint of counselling, Swapnil again felt disheartened. The team encouraged him, reminding him that “never look back, always keep moving forward. Keep trying, and if you succeed, it’s heaven; if not, don’t lose hope — keep working hard.” Inspired by this guidance, he stayed focused and determined.\n\nIn the end, his perseverance and consistent effort paid off, and he secured admission in Rajshree Medical College, Uttar Pradesh, in E.N.T.\n\nHis journey proves that even in moments of despair, with guidance, hope, and hard work, dreams can still come true.",
    image: Swapnil,
  },
];
export default function TestimonialCarousel() {
  const [activeIdx, setActiveIdx] = useState(2);
  const [prevIdx, setPrevIdx] = useState(2);
  const [isAnimating, setIsAnimating] = useState(false);
  const testimonialsRef = useRef(null);
  const scrollContainerRef = useRef(null);

  const scrollToTestimonials = () => {
    if (testimonialsRef.current) {
      testimonialsRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  const handlePrev = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const handleNext = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const handleImageClick = (idx) => {
    if (idx !== activeIdx) {
      setPrevIdx(activeIdx);
      setIsAnimating(true);
      setTimeout(() => {
        setActiveIdx(idx);
        setIsAnimating(false);
      }, 350);
    }
  };

  return (
    <div className="mt-10">
      <section className="w-full mx-auto px-4" ref={testimonialsRef}>
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-2">
            NEET PG Aspirants Share{" "}
            <span className="text-[#ff9245]">Their Experience</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            See how NEET PG aspirants gained clarity and confidence through the
            right counselling support.
          </p>
        </div>

        <div className="relative w-full">
          <div
            id="testimonial-cards"
            ref={scrollContainerRef}
            className="
              flex flex-row flex-nowrap items-start 
              gap-6 mb-8 
              overflow-x-auto overflow-y-visible 
              scrollbar-hide 
              pb-2
              snap-x snap-mandatory
            "
            style={{ minWidth: "100%" }}
          >
            {testimonials.map((t, idx) => {
              const imgSrc = t.image?.src || t.image;

              if (activeIdx === idx) {
                return (
                  <div
                    key={idx}
                    className="
                      flex flex-row bg-white rounded-2xl shadow-lg 
                      border border-[#ff9345] border-2 overflow-hidden 
                      flex-shrink-0 snap-start
                    "
                    style={{
                      width: 620,
                      minWidth: 620,
                      height: 420,
                      minHeight: 420,
                      zIndex: 2,
                      transition:
                        "transform 0.35s cubic-bezier(0.4,0,0.2,1)",
                      transform: "translateX(-4px)",
                    }}
                  >
                    <div
                      className="flex items-center justify-center p-0"
                      style={{ width: 260, height: 420 }}
                    >
                      <img
                        src={imgSrc}
                        alt={t.name}
                        width={260}
                        height={420}
                        loading="lazy"
                        draggable={false}
                        className="rounded-2xl object-cover shadow-md border border-gray-200"
                        style={{ background: "#f8f8f8", height: "420px" }}
                      />
                    </div>

                    <div
                      className="flex flex-col px-8 py-8"
                      style={{ width: 360, height: 420 }}
                    >
                      <div className="text-lg font-bold text-gray-900 mb-1">
                        {t.name}
                      </div>
                      <div className="text-[#ff9345] text-sm font-semibold mb-1">
                        {t.title}
                      </div>

                      {t.subtitle && (
                        <div className="text-gray-700 text-sm font-bold mb-2">
                          {t.subtitle}
                        </div>
                      )}

                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          minHeight: 48,
                        }}
                      >
                        <RiDoubleQuotesR
                          className="w-8 h-8 text-[#ff9345] mb-2"
                          style={{ minWidth: 32, minHeight: 32 }}
                        />
                      </span>

                      <div
                        className="text-gray-800 text-md font-medium mb-2 overflow-y-auto pr-2"
                        style={{
                          flex: 1,
                          minHeight: 0,
                          scrollbarWidth: "thin",
                        }}
                      >
                        {t.text.split("\n").map((line, i) =>
                          line.trim() ? (
                            <p key={i} className="mb-3 leading-6">
                              {line}
                            </p>
                          ) : (
                            <div key={i} className="h-2" />
                          )
                        )}
                      </div>
                    </div>
                  </div>
                );
              }

              return (
                <div
                  key={idx}
                  className="
                    relative flex flex-col items-center 
                    cursor-pointer transition-all duration-300 
                    opacity-90 bg-white rounded-2xl shadow-lg 
                    border border-gray-200 group 
                    flex-shrink-0 snap-start
                  "
                  onClick={() => handleImageClick(idx)}
                  style={{
                    width: 210,
                    height: 420,
                    minWidth: 210,
                    minHeight: 420,
                    padding: 0,
                  }}
                >
                  <div className="w-full h-full flex items-center justify-center">
                    <img
                      src={imgSrc}
                      alt={t.name}
                      width={210}
                      height={420}
                      loading="lazy"
                      draggable={false}
                      className="rounded-2xl w-full h-full object-cover shadow-md border border-gray-200"
                      style={{
                        background: "#f8f8f8",
                        height: "420px",
                        width: "210px",
                      }}
                    />
                  </div>

                  <div className="absolute bottom-0 left-0 w-full px-4 pb-4 pt-8 bg-gradient-to-t from-black/60 via-black/10 to-transparent rounded-b-2xl flex flex-col justify-end">
                    <RiDoubleQuotesL className="w-7 h-7 text-white mb-2" />
                    <p
                      className="text-white text-sm font-medium mb-2 drop-shadow-lg"
                      style={{ textShadow: "0 2px 8px rgba(0,0,0,0.5)" }}
                    >
                      {t.text.split(" ").slice(0, 7).join(" ")}...
                    </p>
                    <div className="text-white font-bold text-base drop-shadow-lg mb-1">
                      {t.name}
                    </div>
                    <div className="text-white text-xs font-semibold drop-shadow-lg mb-2">
                      {t.title}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex items-center justify-center gap-4 mt-6">
          <button
            onClick={handlePrev}
            className="rounded-full bg-gray-100 hover:bg-gray-200 p-2 text-gray-600"
            aria-label="Previous"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>

          <button
            onClick={handleNext}
            className="rounded-full bg-gray-100 hover:bg-gray-200 p-2 text-gray-600"
            aria-label="Next"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </section>
    </div>
  );
}